import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from '../views/not-found/page-not-found.vue'
import WarrantyRegister from '../views/warranty/page/warranty-register.vue'
//import WarrantyRegisterBackup from '../views/warranty/page/warranty-register-backup.vue'
import WarrantySuccess from '../views/warranty/page/warranty-success.vue'
import WarrantyConditionTH from '../views/warranty/page/warranty-condition-th.vue'
import WarrantyConditionEN from '../views/warranty/page/warranty-condition-en.vue'
import SocialBonusForm from '../views/warranty/page/social-bonus-form.vue'
import WarrantyEnterSN from '../views/warranty/page/warranty-enter-sn.vue'
//import WarrantyCheck from '../views/warranty/page/warranty-check.vue'

Vue.use(VueRouter)

const routes = [
  /*{
    path: '/warranty-register-backup',
    name: 'WarrantyRegisterBackup',
    component: WarrantyRegisterBackup,
  },
  {
    path: '/warranty-register-backup/:lot_no',
    name: 'WarrantyRegisterBackup',
    component: WarrantyRegisterBackup,
  },*/
  {
    path: '/warranty-register',
    name: 'WarrantyEnterSN',
    component: WarrantyEnterSN,
  },
  {
    path: '/warranty-register',
    name: 'WarrantyRegister',
    component: WarrantyRegister,
  },
  {
    path: '/warranty-register/:lot_no',
    name: 'WarrantyRegister',
    component: WarrantyRegister,
  },
  {
    path: '/social-form/:lot_no?',
    name: 'SocialBonusForm',
    component: SocialBonusForm,
  },
  {
    path: '/warranty-success',
    name: 'WarrantySuccess',
    component: WarrantySuccess,
  },
  {
    path: '/warranty-condition-th',
    name: 'WarrantyConditionTH',
    component: WarrantyConditionTH,
  },
  {
    path: '/warranty-condition-en',
    name: 'WarrantyConditionEN',
    component: WarrantyConditionEN,
  },
  /*{
    path: '/warranty-check',
    name: 'WarrantyCheck',
    component: WarrantyCheck,
  },*/
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  console.log('-----> ',to.name)
  /*if (
    to.name !== 'WarrantyRegister'
  ) {
    next({ name: 'PageNotFound' })
  } else {
    next()
  }*/
  next()
})

export default router
